import React from "react"
import TableRow from "material-ui/Table/TableRow"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import * as timecardHelper from "../../helpers/timecardHelper"
import { ITimecardDay, IPayrollStatusDocument, ITimecardPriorPeriodData } from "../../models"
import * as colorHelper from "../../helpers/colorHelper"
import AccountStore from "../../stores/AccountStore"

interface IProps {
	userId: string
	filterByPunchHierarchy: boolean
	timecardDays: ITimecardDay[]
	lockData: IPayrollStatusDocument[]
	timecardPriorPeriodData: ITimecardPriorPeriodData
	priorPeriodAdjustMode: boolean
	allowPriorPeriodAdjust: boolean
}

const EmployeeTimecardTotalsRow: React.SFC<IProps> = (props: IProps) => {
	return (
		<TableRow className="EmployeeTimecardTotalsRow">
			{props.timecardDays.map((timecardDay, i) => {
				const locked = timecardHelper.timecardDayLocked(props.userId, timecardDay.LocalStartDayTime, props.lockData, props.priorPeriodAdjustMode, props.allowPriorPeriodAdjust)
				const color = colorHelper.getTotalsRowTextColor(props.timecardPriorPeriodData)
				return (
					<TableRowColumn
						key={i}
						style={{ backgroundColor: locked ? "#EFEFEF" : "white", verticalAlign: "top" }}
					>
						<table style={{ width: "100%", paddingTop: 10, paddingBottom: 10, color: color }}>
							<tbody>
								<tr>
									<td>Total:</td>
									<td>
										{timecardDay.TimeTotals ?
											timecardDay.TimeTotals.TotalHours :
											0
										} hrs
									</td>
								</tr>
								<tr>
									<td>Working Total:</td>
									<td>
										{timecardDay.TimeTotals ?
											timecardDay.TimeTotals.TotalProductiveHours :
											0
										} hrs
									</td>
								</tr>
								{!props.filterByPunchHierarchy && [
									<tr key="Reg">
										<td>Reg:</td>
										<td>{timecardDay.TimeTotals ? timecardDay.TimeTotals.RegularHours : 0} hrs</td>
									</tr>,
									<tr key="OT1">
										<td>OT1:</td>
										<td>{timecardDay.TimeTotals ? timecardDay.TimeTotals.OvertimeHours : 0} hrs</td>
									</tr>,
									!AccountStore.getHideOT2() &&
									<tr key="OT2">
										<td>OT2:</td>
										<td>{timecardDay.TimeTotals ? timecardDay.TimeTotals.DoubleOvertimeHours : 0} hrs</td>
									</tr>,
									timecardDay.TimeTotals && timecardDay.TimeTotals.PayTypeTotals && timecardDay.TimeTotals.PayTypeTotals.sort((a, b) => {
										if (a.PayTypeCode < b.PayTypeCode) return -1
										if (a.PayTypeCode > b.PayTypeCode) return 1
										return 0
									}).map((payTypeTotal, index) =>
										<tr key={index}>
											<td
												style={{ maxWidth: 50, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}
												title={payTypeTotal.PayTypeName}
											>
												{payTypeTotal.PayTypeCode ? payTypeTotal.PayTypeCode : payTypeTotal.PayTypeName}:
											</td>
											<td>{payTypeTotal.TotalHours} hrs</td>
										</tr>
									)
								]}
							</tbody>
						</table>
					</TableRowColumn>
				)
			})}
		</TableRow>
	)
}

export default EmployeeTimecardTotalsRow
